import React from 'react';
import { Container, Typography } from '@mui/material';
import { useParams } from 'react-router-dom';
import CourseNavigation from '../components/CourseNavigation/CourseNavigation';
import RegexPlayground from '../components/RegexPlayground/RegexPlayground';

const PlaygroundPage: React.FC = () => {
  const { courseId } = useParams<{ courseId: string }>();

  if (!courseId) {
    return (
      <Container maxWidth='lg' sx={{ py: 4 }}>
        <Typography variant='h4'>Playground not found</Typography>
      </Container>
    );
  }

  return (
    <>
      <CourseNavigation currentPage='playground' />
      {courseId === 'regex-learning' ? (
        <RegexPlayground />
      ) : (
        <Container maxWidth='lg' sx={{ py: 4 }}>
          <Typography variant='h4'>Playground for {courseId}</Typography>
          <Typography variant='body1'>
            Playground tools for this course are not yet implemented.
          </Typography>
        </Container>
      )}
    </>
  );
};

export default PlaygroundPage;
